module.exports = __webpack_public_path__ + "static/img/2.5a38c32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/2.png
// module id = oT4d
// module chunks = 0